// ScienceClub
import React from 'react';
import ScienceClub from 'views/ScienceClub'

const ScienceClubpage = () => {
  return <ScienceClub />;
};

export default ScienceClubpage;